import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  shape, string, useDataModel, params, arrayOf, bool
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { isEtchVisNavOnPLP } from '../utils/composable/composableUtils';
import { ProductCategoryVisnav } from '../components/ProductCategoryVisnav';

const ProductCategoryVisnavComposable = (props) => {
  const { viewVizNavFilters, customContainerClasses, customHybridClasses } = props;
  const { customContext } = useContext(ExperienceContext);

  const {
    isBrandPage,
    hybridLoading,
    isHybridLayout,
    variables = {}
  } = customContext || {};

  const defaultOptions = {
    variables,
    ssr: true,
    skip: !variables.navParam && !variables.keyword,
  };
  const {
    data: searchModelData,
    loading: searchLoading,
    error: searchError
  } = useDataModel('searchModel', defaultOptions);

  const isEtchVisNavInPLP = isEtchVisNavOnPLP(searchModelData);
  const hasVisnavData = searchModelData?.searchModel?.relatedResults?.visualNavs?.length > 0;

  if (!searchModelData || searchLoading || searchError || hybridLoading) {
    return null;
  }

  if (isEtchVisNavInPLP && !viewVizNavFilters && isBrandPage && !hasVisnavData) {
    return null;
  }

  return (
    <div
      className={isHybridLayout && customHybridClasses ? customHybridClasses : customContainerClasses}
    >
      <ProductCategoryVisnav
        data={searchModelData}
      />
    </div>
  );
};

ProductCategoryVisnavComposable.displayName = 'ProductCategoryVisnavComposable';

ProductCategoryVisnavComposable.propTypes = {
  viewVizNavFilters: PropTypes.bool,
  customContainerClasses: PropTypes.string,
  customHybridClasses: PropTypes.string,
};

ProductCategoryVisnavComposable.defaultProps = {
  viewVizNavFilters: false,
  customContainerClasses: '',
  customHybridClasses: '',
};

ProductCategoryVisnavComposable.dataModel = {
  searchModel: params({ keyword: string(), navParam: string() }).shape({
    metadata: shape({
      contentType: string(),
      hasPLPBanner: bool(),
    }),
    partialTemplates: arrayOf(string()),
    relatedResults: shape({
      visualNavs: arrayOf(
        shape({
          label: string(),
          imageId: string(),
          webUrl: string(),
          categoryId: string(),
          imageURL: string(),
        })
      ),
      visualNavContainsEvents: bool(),
    }),
    searchReport: shape({
      keyword: string(),
    }),
    dimensions: arrayOf(
      shape({
        label: string(),
        refinements: arrayOf(
          shape({
            url: string(),
            refinementKey: string(),
          })
        ),
      })
    ),
  }),
};

export { ProductCategoryVisnavComposable };